import { ArrowUpRight, Phone } from "lucide-react";
import { PORTALS } from "@/lib/portals";
import { PHONE, PHONE_HREF } from "@/lib/api";
import { Reveal, Eyebrow } from "@/components/site/Motion";

export default function SignIn() {
  return (
    <section className="min-h-screen bg-[linear-gradient(180deg,#EAF3FF_0%,#FFFFFF_80%)] px-4 pb-24 pt-44 sm:px-6 lg:px-12" data-testid="signin-page">
      <div className="mx-auto max-w-5xl">
        <Reveal>
          <Eyebrow>Merchant sign in</Eyebrow>
          <h1 className="mt-4 font-display text-4xl font-extrabold tracking-tight text-[#050B1F] sm:text-5xl lg:text-6xl">Sign in to your portal.</h1>
          <p className="mt-4 max-w-xl text-slate-700">Choose the portal for your account. It opens in a new tab.</p>
        </Reveal>
        <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {PORTALS.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.1}>
              <a href={p.url} target="_blank" rel="noopener noreferrer" data-testid={`signin-page-${p.id}-link`}
                className="group flex h-full flex-col justify-between rounded-[2rem] border border-[#0B2A6F]/10 bg-white p-8 transition-[transform,box-shadow] duration-500 hover:-translate-y-2 hover:shadow-[0_30px_80px_-30px_rgba(11,42,111,0.5)] sm:p-10">
                <div>
                  <span className="grid h-14 w-14 place-items-center rounded-2xl bg-[#0B2A6F] font-display text-xl font-extrabold text-lime-300">{p.name[0]}</span>
                  <p className="mt-8 font-display text-3xl font-extrabold tracking-tight text-[#050B1F]">{p.name}</p>
                  <p className="mt-1 font-semibold text-emerald-600">{p.title}</p>
                  <p className="mt-3 text-slate-700">{p.desc}</p>
                </div>
                <span className="mt-10 inline-flex items-center gap-2 self-start rounded-full bg-[#0B2A6F] px-6 py-3 text-sm font-bold text-white transition-colors group-hover:bg-[#050B1F]">
                  Sign in to {p.name} <ArrowUpRight className="h-4 w-4 transition-transform group-hover:rotate-45" />
                </span>
              </a>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2}>
          <p className="mt-10 text-sm text-slate-700">Not sure which portal you use? Call us at{" "}
            <a href={PHONE_HREF} data-testid="signin-page-phone-link" className="inline-flex items-center gap-1 font-bold text-[#0B2A6F] underline-offset-4 hover:underline"><Phone className="h-3.5 w-3.5" />{PHONE}</a>.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
